import React from 'react';
import styles from './Comment.module.scss';
import clsx from 'clsx';

export default function Comment({ label, className }) {
  return <label className={clsx(className && className, styles.hintLabel)}>{label}</label>;
}
